import React from 'react'

import { Callout } from '@/components/Callout'
import { FeaturedProjectsBlock } from '@/payload-types'
import { cn } from '@/utilities/ui'

export function GrantsCallout(props: {
  description: string
  link: FeaturedProjectsBlock['grants']['link']
  className?: string
}) {
  const { description, link, className } = props

  return (
    <div className={cn('bg-olive-2 text-light px-[30px] py-[50px]', className)}>
      <Callout
        variant="light"
        eyebrow={{
          label: 'Grants',
          color: 'highlighter',
        }}
        heading={description}
        link={link}
      />
    </div>
  )
}
